import { StorageItems } from '../../shared/constants/app';
import { decodeFromBase64, encodeToBase64 } from './encryption';

export const addItemToLocalstorage = (
  key: StorageItems,
  value: string | Record<string, any>,
) => {
  localStorage.setItem(
    encodeToBase64(key),
    encodeToBase64(typeof value === 'string' ? value : JSON.stringify(value)),
  );
};

export function getItemFromLocalStorage(
  key: StorageItems,
  itemType: 'string',
): string | null;
export function getItemFromLocalStorage(
  key: StorageItems,
  itemType: 'object',
): Record<string, any> | null;
export function getItemFromLocalStorage(
  key: StorageItems,
  itemType: 'string' | 'object',
): string | Record<string, any> | null {
  const item = localStorage.getItem(encodeToBase64(key));
  if (!item) return null;

  return itemType === 'string'
    ? decodeFromBase64(item)
    : JSON.parse(decodeFromBase64(item));
}

export const removeItemFromLocalstorage = (key: StorageItems) => {
  localStorage.removeItem(encodeToBase64(key));
};

export const addItemToSessionStorage = (
  key: StorageItems,
  value: string | Record<string, any>,
) => {
  sessionStorage.setItem(
    encodeToBase64(key),
    encodeToBase64(typeof value === 'string' ? value : JSON.stringify(value)),
  );
};

export function getItemFromSessionStorage(
  key: StorageItems,
  itemType: 'string',
): string | null;
export function getItemFromSessionStorage(
  key: StorageItems,
  itemType: 'object',
): Record<string, any> | null;
export function getItemFromSessionStorage(
  key: StorageItems,
  itemType: 'string' | 'object',
): string | Record<string, any> | null {
  const item = sessionStorage.getItem(encodeToBase64(key));
  if (!item) return null;

  return itemType === 'string'
    ? decodeFromBase64(item)
    : JSON.parse(decodeFromBase64(item));
}

export const clearLocalStorage = () => {
  localStorage.clear();
};
